import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from '@cr-driver/footer/footer.component';
import { StateHandler } from '@cr-driver/handler/state.handler';
import { HeaderComponent } from '@cr-driver/header/header.component';
import { WattsonComponent } from '@cr-driver/wattson/wattson.component';
import { TranslateModule } from '@ngx-translate/core';

import { PCStatusOverlayComponent } from '@shared/components/pc-status-overlay/pc-status-overlay.component';
import { BreadcrumbHandler } from './core/handler/breadcrumb.handler';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TranslateModule,
    HeaderComponent,
    FooterComponent,
    PCStatusOverlayComponent,
    WattsonComponent,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'Charge Repay Service';

  private breadcrumbHandler = inject(BreadcrumbHandler);

  constructor(
    private router: Router,
    private stateHandler: StateHandler,
  ) {
    this.breadcrumbHandler.initialize();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        const firstUrl = event.url;
        this.stateHandler.setOrigin(firstUrl);
      }
    });
  }
}
